import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    AtomsProvider,
    consultationDataAtom,
    LocalizationContextProvider,
    localizationDataAtom,
    PageName,
    pageNameAtom,
    sellerAtom,
    isActivationCompletedAtom,
    floatingChatDataAtom,
} from '@fiverr-private/seller_pages_toolbox';
import { BIProvider } from '../../components/BIContext';
import { RolePage } from '../../components/RolePage';
import { RolePageContextProvider } from '../../components/RolePageContext';
import {
    gigsAtom,
    ordersAtom,
    portfoliosAtom,
    reviewsDataAtom,
    roleToVariationMappingAtom,
    rolloutsAtom,
    selectedRoleIdAtom,
    sellerRolesAtom,
    sellerHasProfessionsAtom,
} from '../../atoms';
import { AppProps } from './types';

import './index.ve.css';

const App = ({
    currency,
    seller,
    sellerHasProfessions,
    consultationData,
    localizationData,
    rollouts,
    highlightsData,
    isActivationCompleted,
    sellerRolesData,
    reviewsData,
    gigsData,
    ordersData,
    portfoliosData,
    floatingChatData,
}: AppProps) => {
    const { queryParameters } = getContext();

    const queryClient = React.useMemo(() => new QueryClient(), []);

    const selectedRoleId = sellerRolesData.find((role) => role.id === queryParameters.role_id)?.id || null;

    let roleToVariationMapping: Record<string, string> = {};
    if (queryParameters.role_id && queryParameters.variant_id) {
        roleToVariationMapping = {
            [queryParameters.role_id as string]: queryParameters.variant_id as string,
        };
    }

    return (
        <AtomsProvider
            atoms={[
                [sellerAtom, seller],
                [sellerRolesAtom, sellerRolesData],
                [sellerHasProfessionsAtom, sellerHasProfessions],
                [selectedRoleIdAtom, selectedRoleId],
                [roleToVariationMappingAtom, roleToVariationMapping],
                [reviewsDataAtom, reviewsData],
                [gigsAtom, gigsData],
                [consultationDataAtom, consultationData || {}],
                [localizationDataAtom, localizationData],
                [pageNameAtom, 'seller_page' as PageName],
                [ordersAtom, ordersData],
                [rolloutsAtom, rollouts],
                [isActivationCompletedAtom, isActivationCompleted],
                [portfoliosAtom, portfoliosData],
                [floatingChatDataAtom, floatingChatData],
            ]}
        >
            <QueryClientProvider client={queryClient}>
                <RolePageContextProvider highlightsData={highlightsData || {}}>
                    <LocalizationContextProvider currency={currency}>
                        <BIProvider>
                            <RolePage />
                        </BIProvider>
                    </LocalizationContextProvider>
                </RolePageContextProvider>
            </QueryClientProvider>
        </AtomsProvider>
    );
};

export default App;
